export default {
  getFringesItem: (state) => state.fringesItem,
};
